module.exports = "https://img.zhijierongxing.com/saas/img/tabicon3.74afd754.png";